import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import {
  AffiliationForm,
  ContentPanel,
  DropdownAccordion,
  TenantBrandingForm,
  TenantForm,
  Toolbar
} from '../../components'
import { AffiliationsList } from './AffiliationsList'
import {
  useDeleteTenantMutation,
  useSaveAffiliationMutation,
  useTenant,
  useUpdateTenantBrandingMutation,
  useUpdateTenantMutation
} from '../../hooks'
import { useActions, useApplicationName } from '../../store'

const INFORMATION = { id: 1, name: 'Project Information' }
const CREATE_GROUP = { id: 2, name: 'Create a New Group' }
const MANAGE_GROUPS = { id: 3, name: 'Manage Current Groups' }
const BRANDING = { id: 4, name: 'Customize Project Branding' }
const menuOptions = [INFORMATION, CREATE_GROUP, MANAGE_GROUPS, BRANDING]

const PortalAdminPage = () => {
  const [selected, setSelected] = useState(menuOptions[0])
  const navigate = useNavigate()
  const { tenant } = useTenant()
  const applicationName = useApplicationName()
  const { setError } = useActions()

  const { mutate: saveAffiliation } = useSaveAffiliationMutation()
  const { mutate: updateTenant } = useUpdateTenantMutation()
  const { mutate: deleteTenant } = useDeleteTenantMutation()
  const { mutate: updateTenantBranding } = useUpdateTenantBrandingMutation()

  const SelectedForm = () => {
    switch (selected) {
      case INFORMATION:
        return (
          <TenantForm
            formData={{ ...tenant }}
            onSubmit={(data) =>
              updateTenant(
                { data },
                { onSuccess: () => navigate('/' + data.urlSlug) }
              )
            }
            onDelete={(id) =>
              deleteTenant({ id }, { onSuccess: () => navigate('/') })
            }
          />
        )
      case CREATE_GROUP:
        return (
          <AffiliationForm onSubmit={(data) => saveAffiliation({ data })} />
        )
      case MANAGE_GROUPS:
        return <AffiliationsList />
      case BRANDING:
        return (
          <TenantBrandingForm
            formData={{ ...tenant }}
            onSubmit={(data) =>
              updateTenantBranding(
                { data },
                { onSuccess: () => navigate('/' + data.urlSlug) }
              )
            }
          />
        )
      default:
        return null
    }
  }

  if (!tenant) {
    return null
  }
  if (!tenant?.roles?.includes('ADMIN')) {
    setError('You do not have admin permissions')
    return null
  }
  return (
    <Container className='resizing-container'>
      <Helmet>
        <title>Project Settings - {applicationName}</title>
      </Helmet>
      <Toolbar title='Project Settings'>
        <DropdownAccordion
          id='affiliationsManagementSelect'
          title='Select'
          options={menuOptions}
          selectedOption={selected}
          onOptionSelect={setSelected}
          variant='link'
          menuAlign={{ sm: 'left' }}
        />
      </Toolbar>
      <ContentPanel>
        <h2 className='mb-4'>{selected.name}</h2>
        <SelectedForm />
      </ContentPanel>
    </Container>
  )
}

export { PortalAdminPage }
